import { useState } from 'react';
import { profileService } from '../service/profileService.mjs';


export const useProfile = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchProfile = async () => {
    try {
      setLoading(true);
      setError(null);
      const userData = await profileService.getProfile();
    
      setUser(userData);
    } catch (err) {
      setError(err.message || 'Failed to fetch profile');
    } finally {
      setLoading(false);
    }
  };

  const updateProfile = async (profileData) => {
    try {
      setLoading(true);
      setError(null);
      await profileService.updateProfile(profileData);
      // Refetch profile to ensure we have the latest data
      const updatedUser = await profileService.getProfile();
      setUser(updatedUser);
      return true;
    } catch (err) {
      setError(err.message || 'Failed to update profile');
      return false;
    } finally {
      setLoading(false);
    }
  };

  const changePassword = async (passwordData) => {
    try {
      setLoading(true);
      setError(null);
      await profileService.changePassword(passwordData);
      return true;
    } catch (err) {
      setError(err.message || 'Failed to change password');
      return false;
    } finally {
      setLoading(false);
    }
  };

  const deleteAccount = async () => {
    try {
      setLoading(true);
      setError(null);
      await profileService.deleteAccount();
      setUser(null);
      return true;
    } catch (err) {
      setError(err.message || 'Failed to delete account');
      return false;
    } finally {
      setLoading(false);
    }
  };

  return {
    user,
    loading,
    error,
    fetchProfile,
    updateProfile,
    changePassword,
    deleteAccount
  };
};


